module.exports = __webpack_public_path__ + "img/support-perks-btn.a1a825b6.png";